import { render, staticRenderFns } from "./TemplateMarketPreviewItem.vue?vue&type=template&id=456a84e6&scoped=true&"
import script from "./TemplateMarketPreviewItem.vue?vue&type=script&lang=js&"
export * from "./TemplateMarketPreviewItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMarketPreviewItem.vue?vue&type=style&index=0&id=456a84e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a84e6",
  null
  
)

export default component.exports